(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-new-customer-banner"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const codeButton = event.target.closest('.new-customer-banner__code');
    if (codeButton) {
      const banner = codeButton.closest('.new-customer-banner');
      const isVisible = banner.classList.toggle('is-note-visible');
      codeButton.setAttribute('aria-expanded', isVisible ? 'true' : 'false');
      return;
    }

    const copyButton = event.target.closest('.new-customer-banner__copy');
    if (!copyButton) {
      document.querySelectorAll('.new-customer-banner.is-note-visible').forEach((banner) => {
        banner.classList.remove('is-note-visible');
        banner.querySelector('.new-customer-banner__code')?.setAttribute('aria-expanded', 'false');
      });
      return;
    }

    const discountCode = copyButton.dataset.discountCode;
    const originalHtml = copyButton.innerHTML;
    if (copyButton.classList.contains('is-copied')) return;

    navigator.clipboard.writeText(discountCode).then(() => {
      copyButton.classList.add('is-copied');
      copyButton.textContent = 'Copied!';
      setTimeout(() => {
        copyButton.innerHTML = originalHtml;
        copyButton.classList.remove('is-copied');
      }, 2000);
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    document.querySelectorAll('.new-customer-banner.is-note-visible').forEach((banner) => {
      banner.classList.remove('is-note-visible');
      banner.querySelector('.new-customer-banner__code')?.setAttribute('aria-expanded', 'false');
    });
  });
  } catch(e) { console.error(e); }
})();

})();
